require('./sectionTemplateProperties.i18n.json');
require('./sectionTemplateProperties.tpl.html');
require('./sectionTemplateStageApplicability.js');

/*@ngInject*/
const SectionTemplatePropertiesController = function ($rootScope, $scope, $stateParams, $q, $uibModal, $window, currentUserModel, authorizationConstants, localization, sectionTemplateApplicabilityType, sectionTemplateStageApplicability, dataSetUtil, sectionTemplateEditorModel, configurationConstant, productTypes, coreConstant, coreMediator) {

    $scope.viewModel = {
        hasManagePermission: currentUserModel.hasAuthorization(authorizationConstants.MANAGE_CONFIG_SECTION_TEMPLATES),
        sectionTemplate: {},
        applicabilities: [
            sectionTemplateApplicabilityType.OPTIONAL,
            sectionTemplateApplicabilityType.REQUIRED,
            sectionTemplateApplicabilityType.DEFAULT_SELECTED,
            sectionTemplateApplicabilityType.CONDITIONAL
        ],
        productsMultiSelectName: 'productsMultiSelect',
        productTemplates: null,
        productsDelimiter: ',',
        sectionAdapters: [],
        formTemplates: [],
        quotableProductTemplates: [],
        quotableProductTemplatesList: [],
        allProductsItem: {
            name: '',
            value: '-1'
        },
        quoteDocumentTemplateName: null,
        quoteDocumentTemplateDownloadUrl: '',
        displayQuoteDocumentTemplateUploadButton: true,
        displayQuoteDocumentTemplateLink: false
    };

    function init() {
        loadModel();
        loadLocalization();
    }

    function loadModel() {
        loadDataSets().then(function () {
            $scope.viewModel.sectionTemplate = sectionTemplateEditorModel.getSectionTemplate(parseInt($stateParams.sectionTemplateId));

            if (!_.isNil($scope.viewModel.sectionTemplate)) {
                translateProductsFromModel();
                translateStageApplicabilityFromModel();
                translateSectionAdapterFromModel();
                translateQuoteDocumentTemplateFromModel();
            }
        });
    }

    function loadDataSets() {
        var promisesList = [];

        if (_.isEmpty($scope.viewModel.quotableProductTemplates)) {
            promisesList.push(dataSetUtil.getDataSet({
                name: 'Product Templates By Type',
                search: productTypes.QUOTEABLE
            }).then(function (dataSet) {
                $scope.viewModel.quotableProductTemplates = _.map(dataSet.items, function (item) {
                    return {
                        name: item.name,
                        value: item.value
                    };
                });
            }));
        }

        if (_.isEmpty($scope.viewModel.sectionAdapters)) {
            promisesList.push(dataSetUtil.getDataSet({name: 'SectionAdapter Dynamic DataSet Generator'}).then(function (dataSet) {
                $scope.viewModel.sectionAdapter = {
                    name: '',
                    value: ''
                };

                $scope.viewModel.sectionAdapters = _.map(dataSet.items, function (item) {
                    return {
                        name: item.name,
                        value: item.value
                    };
                });
            }));
        }

        if (_.isEmpty($scope.viewModel.formTemplates)) {
            promisesList.push(dataSetUtil.getDataSet({name: 'Proposal/Binder Section Form Template Unique Name Dynamic DataSet Generator'}).then(function (dataSet) {
                $scope.viewModel.formTemplates = _.map(dataSet.items, 'value');
            }));
        }

        return $q.all(promisesList);
    }

    function loadLocalization() {
        localization.getTranslationByKey('sectionTemplateProperties').then(function (translations) {
            $scope.viewModel.placeholders = {
                name: _.get(translations, 'placeholders.name'),
                description: _.get(translations, 'placeholders.description'),
                applicability: _.get(translations, 'placeholders.applicability'),
                stageApplicability: _.get(translations, 'placeholders.stageApplicability'),
                formTemplate: _.get(translations, 'placeholders.formTemplate'),
                sectionAdapter: _.get(translations, 'placeholders.sectionAdapter'),
                products: _.get(translations, 'placeholders.products'),
                multipleProductsSelected: _.get(translations, 'placeholders.multipleProductsSelected'),
                allProductsSelected: _.get(translations, 'placeholders.allProductsSelected'),
                quoteDocumentTemplate: _.get(translations, 'placeholders.quoteDocumentTemplate')
            };

            $scope.viewModel.allProductsItem.name = _.get(translations, 'labels.allProductsItemLabel');

            $scope.viewModel.stageApplicabilities = [{
                name: _.get(translations, 'labels.stageApplicability.' + sectionTemplateStageApplicability.PROPOSAL),
                value: sectionTemplateStageApplicability.PROPOSAL
            }, {
                name: _.get(translations, 'labels.stageApplicability.' + sectionTemplateStageApplicability.BINDER),
                value: sectionTemplateStageApplicability.BINDER
            }, {
                name: _.get(translations, 'labels.stageApplicability.' + sectionTemplateStageApplicability.BOTH),
                value: sectionTemplateStageApplicability.BOTH
            }];

            $scope.getApplicabilityLabel = function (value) {
                return _.get(translations, 'labels.applicability.' + value);
            };
        });
    }

    function translateStageApplicabilityToModel() {
        switch ($scope.viewModel.stageApplicability.value) {
            case sectionTemplateStageApplicability.PROPOSAL:
                $scope.viewModel.sectionTemplate.applicableToProposal = true;
                $scope.viewModel.sectionTemplate.applicableToBinder = false;
                break;

            case sectionTemplateStageApplicability.BINDER:
                $scope.viewModel.sectionTemplate.applicableToProposal = false;
                $scope.viewModel.sectionTemplate.applicableToBinder = true;
                break;

            case sectionTemplateStageApplicability.BOTH:
                $scope.viewModel.sectionTemplate.applicableToProposal = true;
                $scope.viewModel.sectionTemplate.applicableToBinder = true;
                break;
        }
    }

    function translateStageApplicabilityFromModel() {
        if ($scope.viewModel.sectionTemplate.applicableToProposal && $scope.viewModel.sectionTemplate.applicableToBinder) {
            $scope.viewModel.stageApplicability = _.find($scope.viewModel.stageApplicabilities, {value: sectionTemplateStageApplicability.BOTH});
        } else if ($scope.viewModel.sectionTemplate.applicableToProposal) {
            $scope.viewModel.stageApplicability = _.find($scope.viewModel.stageApplicabilities, {value: sectionTemplateStageApplicability.PROPOSAL});
        } else if ($scope.viewModel.sectionTemplate.applicableToBinder) {
            $scope.viewModel.stageApplicability = _.find($scope.viewModel.stageApplicabilities, {value: sectionTemplateStageApplicability.BINDER});
        }
    }

    function translateSectionAdapterToModel() {
        $scope.viewModel.sectionTemplate.adapterBeanName = $scope.viewModel.sectionAdapter.value;
    }

    function translateSectionAdapterFromModel() {
        $scope.viewModel.sectionAdapter = _.find($scope.viewModel.sectionAdapters, {value: $scope.viewModel.sectionTemplate.adapterBeanName});
    }

    function translateProductsToModel() {
        var tempItemList,
            productTemplateIds;

        if ($scope.viewModel.allProductsItem.selected) {
            _.map($scope.viewModel.quotableProductTemplates, function (item) {
                item.selected = true;
            });
        }

        tempItemList = _.filter($scope.viewModel.quotableProductTemplates, function (item) {
            return item.selected;
        });
        productTemplateIds = _.map(tempItemList, 'value');

        if (_.size(tempItemList) === _.size($scope.viewModel.quotableProductTemplates)) {
            // The server will expect an empty list for "all products"
            $scope.viewModel.sectionTemplate.productTemplates = [];
        } else {
            $scope.viewModel.sectionTemplate.productTemplates = _.map(productTemplateIds, function (productTemplateId) {
                return {
                    id: parseInt(productTemplateId)
                };
            });

            if (_.isEmpty($scope.viewModel.sectionTemplate.productTemplates)) {
                // Setting to null here makes the required field indicator work.
                $scope.viewModel.sectionTemplate.productTemplates = null;
            }
        }

        translateProductsFromModel();
    }

    function translateProductsFromModel() {
        var productTemplates;

        $scope.viewModel.productTemplates = null;

        if (!_.isNil($scope.viewModel.sectionTemplate.productTemplates)) {
            productTemplates = _.map($scope.viewModel.sectionTemplate.productTemplates, 'id');

            if (_.isEmpty(productTemplates)) {
                productTemplates = _.map($scope.viewModel.quotableProductTemplates, 'value');
                $scope.viewModel.quotableProductTemplatesList = [];
            } else {
                $scope.viewModel.quotableProductTemplatesList = [$scope.viewModel.allProductsItem];
            }

            $scope.viewModel.quotableProductTemplatesList = $scope.viewModel.quotableProductTemplatesList.concat($scope.viewModel.quotableProductTemplates);

            $scope.viewModel.productTemplates = _.join(productTemplates, $scope.viewModel.productsDelimiter);
        }

        updateQuotableProductTemplatesList();
    }

    function updateQuotableProductTemplatesList() {
        if (_.isEmpty($scope.viewModel.sectionTemplate.productTemplates) && !_.isNil($scope.viewModel.sectionTemplate.productTemplates)) {
            $scope.viewModel.quotableProductTemplatesList = [];
        } else {
            $scope.viewModel.quotableProductTemplatesList = [$scope.viewModel.allProductsItem];
        }

        $scope.viewModel.quotableProductTemplatesList = $scope.viewModel.quotableProductTemplatesList.concat($scope.viewModel.quotableProductTemplates);
    }

    function translateQuoteDocumentTemplateToModel() {
        $scope.viewModel.sectionTemplate.documentTemplateName = $scope.viewModel.quoteDocumentTemplateName;

        $scope.viewModel.displayQuoteDocumentTemplateUploadButton = _.isEmpty($scope.viewModel.quoteDocumentTemplateName);
        $scope.viewModel.displayQuoteDocumentTemplate = !$scope.viewModel.displayQuoteDocumentTemplateUploadButton;
        $scope.viewModel.displayQuoteDocumentTemplateLink = false;
    }

    function translateQuoteDocumentTemplateFromModel() {
        $scope.viewModel.quoteDocumentTemplateName = $scope.viewModel.sectionTemplate.documentTemplateName;

        $scope.viewModel.displayQuoteDocumentTemplateUploadButton = _.isEmpty($scope.viewModel.quoteDocumentTemplateName);
        $scope.viewModel.displayQuoteDocumentTemplate = !$scope.viewModel.displayQuoteDocumentTemplateUploadButton;
        $scope.viewModel.displayQuoteDocumentTemplateLink = $scope.viewModel.displayQuoteDocumentTemplate;
    }

    function getQuoteDocumentTemplateDownloadUrl() {
        let templateFileName = $scope.viewModel.quoteDocumentTemplateName,
            validTemplateFileName = !_.isNil(templateFileName),
            templateFileNamePath = '',
            templateFileNameParameter = '',
            sectionTemplateId = $scope.viewModel.sectionTemplate.id,
            hasUnsavedQuoteDocumentTemplate = sectionTemplateEditorModel.hasUnsavedQuoteDocumentTemplateFile(sectionTemplateId);

        if (validTemplateFileName) {
            templateFileNamePath = `/${encodeURIComponent(templateFileName)}`;
            templateFileNameParameter = ` filename="${encodeURIComponent(templateFileName)}"`
        }

        if (!hasUnsavedQuoteDocumentTemplate) {
            return coreMediator.getSingleUseToken().then((token) => {
               return `/sectionTemplateDownload${templateFileNamePath}?sectionTemplateId=${sectionTemplateId}&t=${encodeURIComponent(token)}&contentDisposition=inline;${templateFileNameParameter}`;
            });
        } else {
            $q.resolve();
        }
    }

    $scope.onChange = function () {
        sectionTemplateEditorModel.setUnsavedPropertiesChanges($scope.viewModel.sectionTemplate.id, true);
        sectionTemplateEditorModel.setValid($scope.viewModel.sectionTemplate.id, isValid());

        $rootScope.$broadcast(configurationConstant.event.SECTION_TEMPLATE_EDITOR_MODEL_UPDATED, $scope.viewModel.sectionTemplate.id);
    };

    function isValid(sectionTemplateId) {
        var result = false, // we need to always return something if the method is intended to return something
            hasName = !_.isEmpty($scope.viewModel.sectionTemplate.name),
            hasProductTemplates = !_.isNil($scope.viewModel.sectionTemplate.productTemplates),
            hasAdapterBeanName = !_.isEmpty($scope.viewModel.sectionTemplate.adapterBeanName),
            hasOrdinalNumber = !_.isNil($scope.viewModel.sectionTemplate.ordinalNumber);

        if (hasName && hasOrdinalNumber && hasProductTemplates && hasAdapterBeanName) {
            result = true;
        }
        return result;
    };

    $scope.onStageApplicabilitySelect = function () {
        translateStageApplicabilityToModel();
        $scope.onChange();
    };

    $scope.onSectionAdapterSelect = function () {
        translateSectionAdapterToModel();
        $scope.onChange();
    };

    $scope.openFileDialogBox = function () {
        if ($scope.viewModel.hasManagePermission) {
            $uibModal.open({
                templateUrl: '/configuration/uploadDocument/uploadDocumentModal.tpl.html',
                controller: 'uploadDocumentModalController',
                windowClass: 'uploadDocumentModal',
                resolve: {},
                keyboard: false,
                backdrop: 'static'
            });
        }
    };

    $scope.removeQuoteDocumentTemplate = function () {
        $scope.viewModel.quoteDocumentTemplateName = null;
        sectionTemplateEditorModel.setQuoteDocumentTemplateFile(parseInt($stateParams.sectionTemplateId), null);

        translateQuoteDocumentTemplateToModel();

        $scope.onChange();
    };

    $scope.onDocumentTemplateDownloadClick = function () {
        getQuoteDocumentTemplateDownloadUrl().then((url) => {
                $window.open(url, '_blank');
        });
    }

    $scope.$on(coreConstant.event.MULTI_SELECT_UPDATED, function (event, itemName) {
        if ($scope.viewModel.productsMultiSelectName === itemName) {
            translateProductsToModel();

            $scope.onChange();
        }
    });

    $scope.$on(coreConstant.event.MULTI_SELECT_CLOSED, function (event, itemName) {
        if ($scope.viewModel.productsMultiSelectName === itemName) {
            $scope.viewModel.allProductsItem.selected = false;
        }
    });

    $scope.$on(coreConstant.event.FILE_UPLOADED, function (event, file) {
        $scope.viewModel.quoteDocumentTemplateName = file.name;
        sectionTemplateEditorModel.setQuoteDocumentTemplateFile(parseInt($stateParams.sectionTemplateId), file.uploadedFile);
        sectionTemplateEditorModel.setUnsavedQuoteDocumentTemplateFile(parseInt($stateParams.sectionTemplateId), true);
        translateQuoteDocumentTemplateToModel();

        $scope.onChange();
    });

    $scope.$on(configurationConstant.event.SECTION_TEMPLATE_EDITOR_MODEL_UPDATED, function (event, sectionTemplateId) {
        if (parseInt($stateParams.sectionTemplateId) === sectionTemplateId) {
            loadModel();
        }
    });

    init();
};

angular.module('ums.configuration')
    .controller('sectionTemplatePropertiesController', SectionTemplatePropertiesController);
